import { createPortal } from 'react-dom';
import { Item, ItemContent, ItemMedia, ItemTitle } from '@/components/ui/item';
import { Spinner } from '@/components/ui/spinner';

function ProcessingNotice({ label }: { label: string }) {
  // Cover only the content column of the hub (not the sidebar); fall back to the whole page.
  const shell = document.querySelector<HTMLElement>('.hub .shell');
  return createPortal(
    <div
      role="alert"
      aria-busy="true"
      style={shell ? { gridColumn: 2, gridRow: 1 } : undefined}
      className={`${shell ? 'absolute' : 'fixed'} inset-0 z-[100] flex items-center justify-center bg-black/30 backdrop-blur-sm`}
    >
      <Item variant="muted" className="w-auto min-w-64 max-w-xs border-border bg-background shadow-lg">
        <ItemMedia>
          <Spinner className="size-5" />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>{label}</ItemTitle>
        </ItemContent>
      </Item>
    </div>,
    shell ?? document.body,
  );
}

export { ProcessingNotice };
